import MegaMenu from './MegaMenu'

export * from './MegaMenu'
export default MegaMenu
